/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// styles
import injectSheet from 'react-jss';
import styles from 'material/embeds/content/shared/logo/partner/partner_styles';



/* ========== ~~~~~~~~~~ EMBED : PARTNER LOGO ~~~~~~~~~~ ========== */
const PartnerLogo = (props) => {
    function isValidURL() {
        const elSettings = props.selectedEmbedStatus.selectedEmbedData.partnerLogo;
        return elSettings.url === undefined || elSettings.url === null || elSettings.url === '' ? false : true;
    }
    return (
        <a className={`partnerlogo ${props.classes.partnerlogo} clickable-${isValidURL()}`} href={props.selectedEmbedStatus.selectedEmbedData.partnerLogo.url} target="_blank" rel="noopener noreferrer" style={props.selectedEmbedStatus.selectedEmbedData.showPartnerLogo ? { backgroundImage: `url(${props.selectedEmbedStatus.selectedEmbedData.partnerLogo.src})` } : { display: 'none' }}><span className={`accessibility`}>Partner Logo</span></a>
    );
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(PartnerLogo);
